import {thousandSeparator} from '@utils/formatter';

angular.module('eva2-angular').filter('thousandSeparator', function() {
  return function(input, ignore) {
    return thousandSeparator(input, ignore);
  };
});
